import BaseModule from "~/vuex/modules/base-module";

let ParkingOptions = {...BaseModule};

ParkingOptions.state = function () {
    let state = BaseModule.state();

    state.endpoints['all'] = '/api/parking-options';

    state.lastDate = null;
    state.sort = {};


    return state;
};

ParkingOptions.actions.updateParkingOptionStatus = async function({commit, getters}, data) {
    let response = await this.axios.post(
        '/api/parking-options/update-status',
        data
    );

    return response.data;
};

ParkingOptions.actions.searchParkingOptions = async function({commit, getters}, data) {
    const page = data.page ?? 1 ;
    const cruiseCode = data.cruise_code ? `filter[cruise_code]=${data.cruise_code}` : '' ;
    let response = await this.axios.get(
        `/api/parking-options?page=${page}&perPage=50&${cruiseCode}`
    );

    return response.data;
};

export default ParkingOptions;
